<template>
  <div
    class="md:h-40 md:w-60 h-28 w-28 bg-white rounded-md flex flex-col items-center text-center md:px-3 px-1 card-shadow"
  >
    <div class="md:mt-2 mt-1 md:text-4xl text-xl text-pink-700">
      <slot></slot>
    </div>
    <div class="md:mt-4 mt-1 text-gray-700 font-bold md:text-xl text-xs">
      {{ title }}
    </div>
    <div class="md:mt-2 mt-1 text-gray-800 md:text-md text-xs font-medium">
      {{ description }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Service-card-component',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
});
</script>

<style lang="scss" scoped></style>
